import * as signalR from "@microsoft/signalr";
import { API_url } from '../api.setup';

const BASE_URL = API_url.replace(/\/api$/, "");

let connection: signalR.HubConnection | null = null;
let isConnecting = false;

export const startNotificationConnection = async () => {
  const token = localStorage.getItem("token");

  if (!token) return null;

 
  if (
    connection &&
    connection.state !== signalR.HubConnectionState.Disconnected
  ) {
    return connection;
  }

  if (isConnecting) return connection;

  isConnecting = true;

  connection = new signalR.HubConnectionBuilder()
    .withUrl(`${BASE_URL}/notificationHub`, {
      accessTokenFactory: () => localStorage.getItem("token") || "",
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  connection.onclose(() => {
    console.log("SignalR disconnected");
  });

  connection.onreconnecting(() => {
    console.log("SignalR reconnecting...");
  });

  connection.onreconnected(() => {
    console.log("SignalR reconnected");
  });

  try {
    await connection.start();
    console.log("SignalR Connected");
  } catch (err) {
    console.error("SignalR connection failed:", err);
  } finally {
    isConnecting = false;
  }

  return connection;
};

export const stopNotificationConnection = async () => {
  if (!connection) return;

  try {
    await connection.stop();
  } catch (e) {
    console.error("SignalR stop error:", e);
  }

  connection = null;
};

export const getNotificationConnection = () => connection;
